/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [""];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/reports/report-items/flagged-questions-list-simple/flagged-questions-list-simple.component.scss.shim.ngstyle.js.pre-build-optimizer.js